import * as BrandIcons from '@fox/icons/brand-icons';
import SvgIcon from '@mui/material/SvgIcon';
import { forwardRef } from 'react';

export type BrandIconName = keyof typeof BrandIcons;

interface BrandIconProps {
	iconName: BrandIconName;
	/** strict size: only small/medium/large */
	size?: 'medium' | 'large';
	title?: string;
}

const SIZE_MAP = {
	medium: '70px',
	large: '105px'
} as const;

export const BrandIcon = forwardRef<SVGSVGElement, BrandIconProps>(({ iconName, size = 'medium', title }, ref) => {
	const IconComponent = BrandIcons[iconName];

	// Strict sizing: do not accept sx/style from callers. Apply explicit
	// width/height on the SVG so consumers cannot override sizing via props.
	const sizeValue = SIZE_MAP[size];

	return (
		<SvgIcon
			ref={ref}
			component={IconComponent}
			color={undefined}
			inheritViewBox
			titleAccess={title}
			style={{ width: sizeValue, height: sizeValue, color: 'transparent' }}
		/>
	);
});
